// eslint-disable-next-line no-restricted-imports
import {on} from 'delegated-events'

on('click', '.js-sponsors-newsletter-tiers .js-sponsors-newsletter-tier-toggle', function (event) {
  const toggleButton = event.currentTarget as HTMLButtonElement
  const form = toggleButton.form
  if (!form) return

  const isDisabled = toggleButton.getAttribute('aria-disabled') === 'true'
  if (isDisabled) return

  const wasChecked = toggleButton.getAttribute('aria-checked') === 'true'
  const newChecked = !wasChecked

  toggleButton.setAttribute('aria-checked', String(newChecked))

  const inputName = toggleButton.getAttribute('data-input-name')!
  const inputValue = toggleButton.getAttribute('data-input-value')!

  if (newChecked) {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = inputName
    input.value = inputValue
    form.appendChild(input)
  } else {
    const input = form.querySelector<HTMLInputElement>(`input[name="${inputName}"][value="${inputValue}"]`)
    if (input) {
      input.remove()
    }
  }

  const container = toggleButton.closest<HTMLElement>('.js-sponsors-newsletter-tiers')!
  const countEl = container.querySelector<HTMLElement>('.js-sponsors-newsletter-tiers-count')!
  const oldSelectedTierCount = parseInt(countEl.textContent!, 10)
  const newSelectedTierCount = oldSelectedTierCount + (newChecked ? 1 : -1)

  countEl.textContent = String(newSelectedTierCount)

  const noTiersSelectedEl = container.querySelector<HTMLElement>('.js-sponsors-newsletter-tiers-none-selected')!
  const countWrapperEl = container.querySelector<HTMLElement>('.js-sponsors-newsletter-tiers-count-wrapper')!
  const anyTiersSelected = countEl.textContent !== '0'

  noTiersSelectedEl.hidden = anyTiersSelected
  countWrapperEl.hidden = !anyTiersSelected
})
